import tw, { styled } from 'twin.macro';

export const PayButton = styled.button`
  margin-top: 5px;
  color: #fff;
  background-color: #3e2a89;
  display: inline-block;
  font-weight: 600;
  line-height: 1.25;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border-radius: 4px;
  padding: 1rem 8px;
  font-size: 14px;
  text-decoration: none;
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  font-family: inherit;
  box-shadow: 0.5px 0.5px 1.5px 0 rgb(50 50 54 / 13%), 0 0 1.5px 0.5px rgb(63 63 68 / 5%);
  width: 100%;
  border: none;
  &.inQuickEditMode {
    width: 70%;
    margin-top: 2rem;
    margin-bottom: 1rem;
  }
`;

export const ModalHeaderContent = styled.div`
  display: flex !important;
  justify-content: space-between !important;
  align-items: center !important;

  > span {
    font-family: var(--fontFamily) !important;
  }
`;

export const PaymentFormWrapper = styled.div`
  font-family: var(--fontFamily) !important;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  p,
  button,
  span,
  input,
  select {
    font-family: var(--fontFamily) !important;
  }

  label {
    color: #666 !important;
  }
`;

export const PaymentForm = styled.div`
  display: grid;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1.5fr 2fr;
  }
`;

export const FormLeft = styled.div`
  padding: 10px;
  background-color: #eee;
`;

export const MerchantImage = styled.div`
  border-radius: 10px;
  max-width: 150px;
  > img {
    width: 100%;
    display: block;
    border-radius: inherit;
  }
`;

export const PaymentInfo = styled.div`
  > div {
    > h2,
    h3 {
      margin: 0;
    }

    > #item {
      width: fit-content;
      margin-left: auto;
      margin-bottom: 30px;
    }

    padding: 20px 15px;
    margin: 10px 0;
    border-radius: 10px;
    background-color: #38383b;
    color: #ffff;
  }
`;

export const FormRight = styled.div`
  padding: 25px 10px;
  margin: 0;
`;

export const CardElementWrapper = styled.div`
  margin-bottom: 20px;
  > div {
    padding: 12px 16px;
    border: 1px solid rgba(34, 36, 38, 0.15);
    border-radius: 0.28571429rem;
  }
  > span {
    display: block;
    color: red;
  }
`;

export const Field = styled.div`
  margin: 10px 0;
  display: flex;
  flex-direction: column;

  > label {
    display: block;
    font-weight: 600;
  }

  > input {
    width: 100%;
  }

  > select {
    border-radius: 0.3rem;
  }

  > span {
    display: block;
    color: red;
  }
`;

export const Fields = styled.div`
  display: grid;

  @media screen and (min-width: 768px) {
    grid-template-columns: 1fr 1fr;
    gap: 15px;
  }
`;

export const SubmitButton = styled.div`
  margin-top: 10px;
  margin-left: auto;
  width: fit-content;
  > button {
    background-color: #00a0c6;
    color: white;
    font-weight: 600;
    padding: 12px 25px;
    outline: none;
    border: none;
    border-radius: 0.3rem;
    cursor: pointer;
    transition: 300ms;

    :hover {
      background-color: #0187a7;
    }

    :disabled {
      background-color: #ccc;
    }
  }
`;
